import {
	Alert,
	Box,
	Button,
	DialogTitle,
	MenuItem,
	TextField,
	Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import LoadingButton from "../../../../../../design/wilya-loading-button";
import { changeUserStatus } from "../../../../store/gat-admin-slice";
import useSupervisorsData from "../controllers/use-supervisors-data";

export default function ConfirmDialog({
	open,
	onClose,
	action,
	text,
	title,
	item,
}: {
	open: boolean;
	onClose: () => void;
	action: () => void;
	text: string;
	title?: string;
	item?: any;
}) {
	const { updateUserStatus, companyUsers, changeUserStatusErrorMessage } =
		useSupervisorsData();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [selectedUser, setSelectedUser] = useState<number | null>(null);

	const { id, isActive, username, assignedWorkers } = item;

	const handleSubmit = () => {
		dispatch(
			changeUserStatus({
				userId: id,
				isActive: !isActive,
				alternateSupervisorId: selectedUser ?? null,
			})
		);
	};
	const associatedUsers = companyUsers.filter(
		(user: { id: number; isActive: boolean }) => user.id !== id && user.isActive
	);

	return (
		<Dialog
			open={open}
			// TransitionComponent={Transition}
			keepMounted
			onClose={() => onClose()}
		>
			<DialogTitle>
				{isActive ? t("users_deactivate-user") : t("users_activate-user")}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id='alert-dialog-slide-description'>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontSize: "16px",
							fontWeight: 400,
							lineHeight: "28px",
							color: "#000000DE",
						}}
					>
						{isActive
							? t("users_confirm-deactivate", { name: username })
							: t("users_confirm-activate", { name: username })}
					</Typography>

					{assignedWorkers > 0 && isActive ? (
						<Box mt={1}>
							<Alert severity='error'>
								{t("users_reassign-workers-notice", { total: assignedWorkers })}
							</Alert>
							<TextField
								label={t("users_select-supervisor")}
								variant='filled'
								select
								fullWidth
								sx={{
									marginTop: "8px",
								}}
								value={selectedUser || ""}
								onChange={(e) => {
									const user = associatedUsers.find(
										(user: { id: number }) =>
											user.id === parseInt(e.target.value)
									);
									setSelectedUser(user ? parseInt(user.id) : null);
								}}
							>
								{associatedUsers.length > 0 ? (
									associatedUsers.map(
										(user: {
											id: number;
											firstName: string;
											lastName: string;
										}) => (
											<MenuItem key={user.id} value={user.id}>
												{`${user.firstName} ${user.lastName}`}
											</MenuItem>
										)
									)
								) : (
									<MenuItem disabled value=''>
										<em>{t("users_no-associated-supervisor")}</em>
									</MenuItem>
								)}
							</TextField>
						</Box>
					) : null}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ padding: "20px 45px" }}>
				<Button onClick={() => action()} variant='text'>
					{t("common_cancel")}
				</Button>
				<LoadingButton
					onClick={handleSubmit}
					variant='contained'
					color='primary'
					disabled={assignedWorkers > 0 && isActive && !selectedUser}
					loading={
						updateUserStatus === "pending" || updateUserStatus === "fulfilled"
					}
				>
					{isActive ? t("users_deactivate") : t("users_activate")}
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
}
